// Replies can come from instructors or students; only instructor replies
// count as the question being answered.
export const isInstructorReply = (reply) => reply.authorRole !== 'student';

const PORTAL_BASENAME = '/portal';

export function sessionQnaPath(sessionId) {
  return `${PORTAL_BASENAME}/session-qna/${sessionId}`;
}

// Opens (or refocuses) the session's Q&A chat in a small popup window. Returns the
// window, or null when the browser blocked it so the caller can fall back to a link.
export function openQnaPopup(sessionId) {
  const popup = window.open(
    sessionQnaPath(sessionId),
    `session-qna-${sessionId}`,
    'popup=yes,width=420,height=700,resizable=yes,scrollbars=yes'
  );
  if (popup) popup.focus();
  return popup || null;
}

export const hasInstructorReply = (question) => (question.replies || []).some(isInstructorReply);

export const isAnswered = (question) => hasInstructorReply(question) || Boolean(question.answeredAt);
